import { Site } from '@ps/web-core-enums';
import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import RegulatoryCheckboxes from '@swf/components/RegulatoryCheckboxes/RegulatoryCheckboxes';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import { TXTWCL_Terms_of_Service, TXTWCL_Your_Agreement } from './RMFTermsOfService.messages.json';

const RMFTermsOfService = () => {
  const variant = 'rmf';
  const isCAON = useSelector(select.cms.getSiteId) === Site.CAON;

  return (
    <Container
      page={RMFTermsOfService}
      headerProps={{ title: <Translation {...TXTWCL_Your_Agreement} /> }}
      pageTopTitle={<Translation {...TXTWCL_Terms_of_Service} />}
    >
      <fieldset>
        <RegulatoryCheckboxes
          variant={variant}
          isSelectAllToggleVisible={variant === 'rmf' && isCAON}
        />
      </fieldset>
      <CTAButton />
    </Container>
  );
};

RMFTermsOfService.displayName = 'RMFTermsOfService';

export default RMFTermsOfService;
